const Alert = (props) => {
    return <div>{props.children}</div>
}

export default Alert;